import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

import { Alert } from '@buildoutinc/blueprint-react/ui/Alert';

interface Props extends React.ComponentPropsWithoutRef<typeof Alert> {
  error?: string | null;
  errors?: string[] | null;
}

export function ErrorsAlert({ error, errors, ...props }: Props) {
  if (error) {
    errors = [error];
  }

  if (!errors?.length) {
    return null;
  }

  return (
    <Alert severity="warning" withIcon {...props}>
      <FontAwesomeIcon icon={faCircleExclamation} />
      {errors.map(error => (
        <div key={error}>{error}</div>
      ))}
    </Alert>
  );
}
